<template>
  <b-container class="create-service-container">
    <b-row>
      <b-col md="12">
        <h2 class="float-left">{{ isEdit ? 'Szolgáltatás szerkesztése' : 'Új szolgáltatás hozzáadása' }}</h2>
      </b-col>
    </b-row>
    <b-row class="first-row">
      <b-col md="8"
        ><b-form-group id="service-name">
          <legend>Cím</legend>
          <b-form-input
            id="service-name"
            placeholder="Szolgáltatás neve..."
            v-model="name"
            type="text"
            class="border inputFieldAlign"
          >
          </b-form-input>
          <input-error :v-if="nameError.length > 0" :errors="[nameError]" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group id="service-link">
          <legend>Link</legend>
          <b-form-input
            id="service-link"
            placeholder="http://vali.hu"
            v-model="link"
            type="text"
            class="border inputFieldAlign"
          >
          </b-form-input>
          <input-error :v-if="linkError.length > 0" :errors="[linkError]" />
        </b-form-group>
      </b-col>
      <b-col md="2 mt-3">
        <b-form-group>
          <b-form-checkbox
            id="blank_checkbox"
            v-model="openLinkInBlank"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
            class="mt-3"
          >
            Külső link
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-button @click="save" variant="primary" class="save-button">Mentés</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { createService, editService, getService } from '../../api/service'
import InputError from '../../components/InputError.vue'
export default {
  name: 'CreateService',
  components: { InputError },
  data: function() {
    return {
      name: '',
      link: '',
      openLinkInBlank: false,
      nameError: '',
      linkError: ''
    }
  },
  created: async function() {
    if (this.isEdit) {
      const service = await getService(this.$route.query.id)
      this.name = service.name
      this.link = service.link
      this.openLinkInBlank = service.openLinkInBlank
    }
  },
  computed: {
    isEdit: function() {
      return !!this.$route.query.id
    }
  },
  methods: {
    clearErrors: function() {
      this.nameError = ''
      this.linkError = ''
    },
    resetValues: function() {
      this.name = ''
      this.link = ''
    },
    save: async function() {
      try {
        this.clearErrors()
        const data = { name: this.name, link: this.link, openLinkInBlank: this.openLinkInBlank }
        if (this.isEdit) {
          await editService(data, this.$route.query.id)
        } else {
          await createService(data)
          this.resetValues()
          this.$router.push('/contents/services')
        }
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'success',
            message: this.isEdit ? 'Szolgáltatás módosítása sikeres!' : 'Szolgáltatása feltöltése sikeres!'
          }
        })
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data && e.response.data.details) {
          const errors = e.response.data.details
          errors.forEach(error => {
            if (error.path.includes('name')) {
              this.nameError = error.message
            }
            if (error.path.includes('link')) {
              this.linkError = error.message
            }
          })
        } else throw e
      }
    }
  }
}
</script>
<style scoped>
.float-left {
  float: left;
}
.form-group legend {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}
.save-button {
  width: 100% !important;
}
.create-service-container {
  position: relative;
}
.preview-container {
  position: absolute;
  top: 0px;
  right: 0px;
  min-height: 365px;
  width: 500px;
}
</style>
